<template>
  <div class="main-box">
    <el-form class="form-inline" :inline="true" size="small">
      <el-form-item label="">
        <el-input v-model="search.keywords" placeholder="请输入订单号" size="small" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="search.refund_status" placeholder="请选择退款状态" clearable>
          <el-option :key="1" label="未退款" :value="1"></el-option>
          <el-option :key="2" label="已退款" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="search.invoice_status" placeholder="请选择开票状态" clearable>
          <el-option :key="1" label="未开票" :value="1"></el-option>
          <el-option :key="2" label="已开票" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="search.return_status" placeholder="请选择退票状态" clearable>
          <el-option :key="1" label="未退票" :value="1"></el-option>
          <el-option :key="2" label="已退票" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
            size="small"
            v-model="dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="提交开始日期"
            end-placeholder="提交结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
      </el-form-item>
    </el-form>
    <el-table
        :data="tableData"
        ref="rfTable"
        style="width: 100%"
        size="mini"
        @selection-change="handleSelectionChange">
      <el-table-column
          prop="name"
          label="订单用户"
          align="left"
          min-width="250">
        <template slot-scope="scope">
          <div v-if="scope.row.member_name" class="member-box">
            <img :src="scope.row.member_avatar" />
            <div>
              <div>{{scope.row.member_name}}（{{scope.row.member_user_id}}）</div>
              <div>{{scope.row.member_mobile}}</div>
            </div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="order_sn"
          label="订单号"
          align="center"
          width="150">
      </el-table-column>
      <el-table-column
          prop="invoice_amount"
          label="发票金额"
          align="center"
          width="120">
      </el-table-column>
      <el-table-column
          prop="mobile"
          label="开票人"
          align="left"
          width="200">
        <template slot-scope="scope">
          <div>手机：{{scope.row.mobile}}</div>
          <div>邮箱：{{scope.row.email}}</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="invoice"
          label="发票信息"
          align="left"
          width="300">
        <template slot-scope="scope">
          <div>{{scope.row.type==1 ? '普通发票' : '专用发票'}}-{{scope.row.header_type==1 ? '个人' : '企业'}}</div>
          <div>发票抬头：{{scope.row.name}}</div>
          <div v-if="scope.row.duty_number">单位税号：{{scope.row.duty_number}}</div>
          <div v-if="scope.row.type==2">开户银行：{{scope.row.bank}}</div>
          <div v-if="scope.row.type==2">银行账号：{{scope.row.card_number}}</div>
          <div v-if="scope.row.type==2">企业地址：{{scope.row.address}}</div>
          <div v-if="scope.row.type==2">企业电话：{{scope.row.tell}}</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="is_refund"
          label="退款状态"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-tag type="success" size="small" v-if="scope.row.is_refund==0">未退款</el-tag>
          <el-tag type="danger" size="small" v-if="scope.row.is_refund==1">已退款</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="is_invoice"
          label="开票状态"
          align="center"
          width="100">
        <template slot-scope="scope">
          <el-tag type="danger" size="small" v-if="scope.row.is_invoice==0">未开票</el-tag>
          <el-popover v-if="scope.row.is_invoice==1"
              placement="top"
              width="300"
              trigger="hover">
              <div class="font-12">发票号码：{{scope.row.invoice_number}}</div>
              <div class="font-12">发票图片：
                <viewer :images="scope.row.imgs">
                  <img :src="scope.row.invoice_img" width="100" height="100">
                </viewer>
              </div>
            <el-tag type="success" size="small" slot="reference">已开票<i class="el-icon-warning-outline"></i></el-tag>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
          prop="invoice_return"
          label="退票状态"
          align="center"
          width="120">
        <template slot-scope="scope">
          <el-tag type="danger" size="small" v-if="scope.row.invoice_return==0">未退票</el-tag>
          <el-tooltip class="item" effect="dark" :content="scope.row.invoice_return_remark" placement="top-start" v-if="scope.row.invoice_return==1">
            <el-tag type="success" size="small">已退票<i class="el-icon-warning-outline"></i></el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
          prop="finish_time"
          label="时间时间"
          align="center"
          width="150">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.is_refund==0 && scope.row.is_invoice==0">
            <el-button type="text" size="small" @click="issue(scope.row)">开票</el-button>
          </div>
          <div v-else-if="scope.row.is_invoice==1 && scope.row.invoice_return==0">
            <el-button type="text" size="small" @click="refund(scope.row)">退票</el-button>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :total="search.total">
    </el-pagination>
    <el-dialog
        title="开票"
        :visible.sync="showDialog"
        :destroy-on-close="true"
        width="700px">
      <issue-invoice :id="itemId" :callback="function () { itemId=0; showDialog=false; getList()}"></issue-invoice>
    </el-dialog>
  </div>
</template>
<script>

import IssueInvoice from "@/components/Order/IssueInvoice";
export default {
  components: {
    IssueInvoice
  },
  data() {
    return {
      info: false,
      source_domain: this.config.SOURCE_DOMAIN,
      search: {
        current_page: 1,
        total: 0,
        limit: 10,
        keywords: '',
        refund_status: '',
        invoice_status: '',
        return_status: ''
      },
      tableData: [],
      dateRange: ['',''],
      showDialog: false,
      itemId: 0
    };
  },
  created() {
    this.getList();
  },
  mounted() {
  },
  computed: {},
  methods: {
    issue(item) {
      this.itemId = item.id
      this.showDialog = true
    },
    refund(item) {
      this.$prompt('请输入退票原因', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /[\d\D]+/,
        inputErrorMessage: '请输入退票原因',
        inputPlaceholder: '请输入退票原因',
      }).then(({ value }) => {
        if(!value) {
          this.fail('请输入退票原因')
          return false
        }
        this.$api.order.financeInvoiceRefund({id:item.id,remark:value},res=>{
          if(res.errcode==0) {
            this.success(res.errmsg)
            this.getList()
          } else {
            this.fail(res.errmsg)
          }
        })
      }).catch(() => {
      });
    },
    getList() {
      var that = this
      that.showLoading()
      var param = {
        page: that.search.current_page,
        page_size: that.search.limit,
        keywords: that.search.keywords,
        invoice_status: that.search.invoice_status,
        refund_status: that.search.refund_status,
        return_status: that.search.return_status,
      }
      if(this.dateRange) {
        param.start_time = this.dateRange[0]
        param.end_time = this.dateRange[1]
      }
      this.$api.order.financeInvoiceIndex(param, function (res) {
        that.hideLoading()
        if (res.errcode == 0) {
          that.tableData = res.data.data
          that.search.current_page = res.data.current_page
          that.search.total = res.data.total
        } else {
          that.fail(res.errmsg)
        }
      })
    },
    handleSearch() {
      this.search.current_page = 1
      this.getList()
    },
    handleSelectionChange(rows) {
    },
    handleCurrentChange(val) {
      this.search.current_page = val
      this.getList()
    },
    handleSizeChange(val) {
      this.search.current_page = 1
      this.search.limit = val
      this.getList()
    }
  }
};
</script>
<style scoped>
</style>
